'use client';

import { useEffect } from 'react';

import ChannelService from '@/lib/channel_talk';
import { NEXT_PUBLIC_CHANNEL_TALK_PLUGIN_KEY } from '@/lib/env';

export default function CommonChannelTalk() {
  useEffect(() => {
    const channelTalk = new ChannelService();

    channelTalk.loadScript();
    channelTalk.boot({
      pluginKey: NEXT_PUBLIC_CHANNEL_TALK_PLUGIN_KEY || 'unknown plugin key',
    });
  }, []);

  return null;
}
